import styled, { keyframes } from "styled-components";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";

const spinnerRotation = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
  margin-top: 14px;
`;

export const DeviationHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DeviationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DeviationRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: baseline;
  gap: 12px;
`;

export const DeviationSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border: 1px solid ${ColorV2.DarkAmbigiousYellow};
  border-radius: 12px;
  background: ${ColorV2.UnplannedAbsenceYellow};
`;

export const DeviationValue = styled(Text)`
  color: ${ColorV2.Blue1};
  white-space: nowrap;
`;

export const LoadingSpinner = styled.span`
  width: 28px;
  height: 28px;
  border: 3px solid ${ColorV2.Blue6};
  border-top-color: ${ColorV2.Blue1};
  border-radius: 50%;
  animation: ${spinnerRotation} 0.8s linear infinite;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ShiftInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`;

export const SummaryLoader = styled.div`
  display: flex;
  justify-content: center;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
`;

export const SummaryRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
